/* eslint-disable */
import { useState, useMemo, useEffect } from 'react';
import PropTypes, { number } from 'prop-types';
import { Form, Row, Col, Select } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import InfoModal from 'components/InfoModal/InfoModal';
import { ALERT_ERROR_TYPE } from 'constants/alertTypes';
import { showAlert } from 'actions/alert.actions';
import { videoSamples, splitBase64 } from 'utils/fileVideosBase64Parts';
import {
  selectCatalogByName,
  selectCatalogs,
  selectfirmanteByUsuario
} from 'selectors/catalogos.selectors';
import { upsertMonitoreosInternet, sendPartVideosInternet } from 'actions/monitoreos.actions';
import { PROCESOS_ELECTORALES } from 'constants/nombresCatalogos';
import {
  formatoCreacionMonitoreoInternet,
  formatoEdicionMonitoreoInternet,
  formatFromBackToForm,
  formatoMuestrasHallazgos
} from 'adapters/formatoMonitoreoInternet';
import { Modal, Accordion, LoadingCard, EstatusFormulario } from 'components';
import {
  newScrollToErrorField,
  encontrarActiveKeyPorValor
} from 'utils/form/newScrollToErrorField';
import { selectAuthState, selectMenuState } from 'selectors/auth.selector';
import { getMenuPermissions } from 'utils/getMenuPermissions';
import { NOMBRE_MENU_INTERNET, NOMBRE_MENU_PERMISO_VALIDAR } from 'constants/menuNombres';
import * as fieldMsgs from 'constants/formFieldsMessages';
import AcuerdoCOF from './components/AcuerdoCOF';
import Beneficiados from '../../../Beneficiados/Beneficiados';
import DatosGenerales from './components/DatosGenerales';
import Firma from './components/Firma';
import Hallazgos from './components/Hallazgos';
import UbicacionWebHallazgo from './components/UbicacionWebHallazgo';
import { useSetImagesFields } from '../../hooks/useSetImagesFields';
import { useSetBeneficiados } from '../../hooks/useSetBeneficiados';
import { useSetSignerFields } from '../../hooks/useSetSignerFields';

import { generarPDFMonitoreos } from 'services/monitoreos.service';

import './ModalFormularioMonitoreo.scss';

const identificadoresForm = {
  datos_generales: [
    'idEstado',
    'idProcesoEspecifico',
    'idMunicipio',
    'idAmbito',
    'idDistritoLoc',
    'idDistritoFed'
  ],
  ubicacion_web_hallazgo: ['fecha_busqueda', 'hora_busqueda', 'plataforma_digital', 'URL'],
  beneficiados: ['tipo_beneficio'],
  firma: ['firmas'],
  acuerdo_cof: ['fecha_acuerdo_aprobado']
};

export const ModalFormularioMonitoreo = ({ onClose, visible, initialData, pagina, pageSize, onCancel }) => {
  /**
   * Este form nos sirve para vincular todos los formularios
   * internos de cada una de las secciones en uno solo
   */
  const [form] = Form.useForm();
  const [tipoBeneficiadoInicial, setTipoBeneficiadoInicial] = useState(null);
  const dispatch = useDispatch();
  const setImagesFields = useSetImagesFields();
  const setSignerFields = useSetSignerFields();
  const [reasonCancel, setReasonCancel] = useState(false);
  const [activeKey, setActiveKey] = useState([]);
  const [isVisibleSuccesModal, setIsVisibleSuccessModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const menu = useSelector(selectMenuState);
  const [idProcesoGeneral, setIdProcesoGeneral] = useState(0);

  const procesosCat = useSelector(selectCatalogByName(PROCESOS_ELECTORALES));
  const procesosElectorales = procesosCat.map((proceso) => ({
    ...proceso,
    nombreProcesoEspecifico: proceso?.nombreProcesoEspecifico?.replace('Ã±', 'ñ')
  }));

  const { data } = useSelector(selectAuthState);
  const idUsuario = useSelector(selectfirmanteByUsuario(data.name));
  // const datosUser = useSelector((state) => state.validarUsuario.data);
  const catalogos = useSelector(selectCatalogs);
  const setBeneficiados = useSetBeneficiados();

  const processMuestras = async (muestrasOrdenadas) => 
  {
    for (const m of muestrasOrdenadas) 
    {
      if (m.muestra?.length > 1024 * 1024) 
      {
        const parts = splitBase64(m.muestra, 1024 * 1024);
        for (let index = 0; index < parts.length; index++) 
        {
          await sendPartVideosInternet(m.idMuestra, m.idHallazgo, index + 1, parts.length, parts[index]);
        }
      } else {
        await sendPartVideosInternet(m.idMuestra, m.idHallazgo, 1, 1, m.muestra);
      }
    }
  };
  

  const handleCancel = () => {
    onCancel();
    setActiveKey([]);
    form.resetFields();
  };

  const handleOK = async () => 
  {
    setIsLoading(true);
    try 
    {
      const values = await form.validateFields();

      if (values.beneficiados.length === 0) 
      {
        dispatch(showAlert('Debes registrar al menos un beneficiado', ALERT_ERROR_TYPE));
        setActiveKey('beneficiados');
        return;
      }
      let payload = {};
      let idNewMonitoreo = 0;
      
      if (!initialData) 
      {
        // Creación de Monitoreo
        payload = formatoCreacionMonitoreoInternet(values, catalogos);

        // Se realiza limpieza de valores innecesarios cuando se guarda un beneficiado genérico
        if(values.tipo_beneficio == 1) {
          payload?.formatos?.toUpdate?.[0]?.beneficiados?.forEach(element => {
            if(element.estatus != 0) {
              element.estado            = '';
              element.idMunicipio       = null;
              element.municipio         = '';
              element.nombreBeneficiado = '';
              element.idContabilidad    = 0;
            }
          });
        }

        const { success, hallazgos: hallazgosMonitoreo, idMonitoreo } = await dispatch(
          upsertMonitoreosInternet(payload, pagina, pageSize) 
        );
        if (success) 
        {
          const hallazgos = formatoMuestrasHallazgos(values.hallazgos);

          // Obtenemos el id del nuevo monitoreo generado
          idNewMonitoreo  = idMonitoreo;

          // Variable a enviar para generar PDF del monitoreo
          let monitoreoPDF = [{
              idMonitoreo: payload.idMonitoreo > 0? payload.idMonitoreo : idNewMonitoreo
            , idTipoMonitoreo: payload.idTipoMonitoreo
            , tiposActa : [{ "id": 5 }]
          }];

          const muestrasOrdenadas = videoSamples(hallazgosMonitoreo, hallazgos);
          if (muestrasOrdenadas.length > 0) 
          {
            processMuestras(muestrasOrdenadas)
              .then(async () => {
                setIsVisibleSuccessModal(true);
                onClose();
                setIdProcesoGeneral(0);
                setActiveKey([]);
                form.resetFields();

                // Se genera PDF una vez que se han almacenado las Muestras
                let generoPDF = await generarPDFMonitoreos(monitoreoPDF);

                if(generoPDF)
                {
                  console.log('Se generó correctamente el PDF');
                }else{
                  console.log('Error al generar el PDF');
                }
              })
              .catch((error) => {
                console.error('Error procesando las muestras:', error);
              });              
          } else {
            setIsVisibleSuccessModal(true);
            setIdProcesoGeneral(0);
            onClose();
            setActiveKey([]);
            form.resetFields();

            // Se genera PDF una vez que se han almacenado las Muestras
            let generoPDF = await generarPDFMonitoreos(monitoreoPDF);

            if(generoPDF)
            {
              console.log('Se generó correctamente el PDF');
            }else{
              console.log('Error al generar el PDF');
            }
          }
        }
      }

      if (initialData) 
      {
        // Edición de Monitoreos
        payload = formatoEdicionMonitoreoInternet(values, catalogos, initialData);

        // Se realiza limpieza de valores innecesarios cuando se guarda un beneficiado genérico
        if(values.tipo_beneficio == 1) {
          payload?.formatos?.toUpdate?.[0]?.beneficiados?.forEach(element => {
            if(element.estatus != 0) {
              element.estado            = '';
              element.idMunicipio       = null;
              element.municipio         = '';
              element.nombreBeneficiado = '';
              element.idContabilidad    = 0;
            }
          });
        }

        const { success, hallazgos: hallazgosMonitoreo } = await dispatch(
          upsertMonitoreosInternet(payload, pagina, pageSize) 
        );

        if (success) 
        {
          // console.log('hallazgosMonitoreo: ', hallazgosMonitoreo);

          // Convertir `hallazgosMonitoreo` en un arreglo si no lo es
          const hallazgosArray = Array.isArray(hallazgosMonitoreo) ? hallazgosMonitoreo : [hallazgosMonitoreo];

          const hallazgos = formatoMuestrasHallazgos(values.hallazgos);
          const muestrasOrdenadas = videoSamples(hallazgosArray, hallazgos);

          // Variable a enviar para generar PDF del monitoreo
          let monitoreoPDF = [{
              idMonitoreo: payload.idMonitoreo > 0? payload.idMonitoreo : idNewMonitoreo
            , idTipoMonitoreo: payload.idTipoMonitoreo
            , tiposActa : [{ "id": 5 }]
          }];
          if (muestrasOrdenadas.length > 0) 
          { 
            processMuestras(muestrasOrdenadas)
              .then(async () => {
                setIsVisibleSuccessModal(true);
                setIdProcesoGeneral(0);
                onClose();
                setActiveKey([]);
                form.resetFields();

                // Se genera PDF una vez que se han almacenado las Muestras
                let generoPDF = await generarPDFMonitoreos(monitoreoPDF);

                if(generoPDF)
                {
                  console.log('Se generó correctamente el PDF');
                }else{
                  console.log('Error al generar el PDF');
                }
              })
              .catch((error) => {
                console.error('Error procesando las muestras:', error);
              });
          } else {
            setIsVisibleSuccessModal(true);
            setIdProcesoGeneral(0);
            onClose();
            setActiveKey([]);
            form.resetFields();

            // Se genera PDF una vez que se han almacenado las Muestras
            let generoPDF = await generarPDFMonitoreos(monitoreoPDF);

            if(generoPDF)
            {
              console.log('Se generó correctamente el PDF');
            }else{
              console.log('Error al generar el PDF');
            }
          }

          
        }  
      }

    } catch (error) {
      const { errorFields } = error;
      console.log('errorFields: ', error);
      if (errorFields) {
        const [firstError] = errorFields;
        const identifierForm = encontrarActiveKeyPorValor(
          identificadoresForm,
          firstError?.name?.[0]
        );
        if (identifierForm) {
          newScrollToErrorField(errorFields, form);
          setActiveKey([`${identifierForm}`]);
        } else {
          setActiveKey([`${newScrollToErrorField(errorFields, form)}`]);
        }
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleCollapseChange = (key) => {
    setActiveKey(key);
  };

  const getRandomInt = (max) => {
    return Math.floor(Math.random() * max);
  };
  const items = useMemo(
    () => [
      {
        key: 'hallazgos',
        label: 'Hallazgos',
        forceRender: true,
        children: <Hallazgos form={form} isLoading={isLoading} />
      },
      {
        key: 'datos_generales',
        label: 'Datos generales',
        forceRender: true,
        children: (
          <DatosGenerales
            form={form}
            folio={initialData?.tableRow !== undefined ? initialData.tableRow.folio : null}
            isLoading={isLoading}
            idProcesoEsp = { idProcesoGeneral }
          />
        )
      },
      {
        key: 'beneficiados',
        label: 'Beneficiados',
        forceRender: true,
        children: (
          <Beneficiados
            form={form}
            isLoading={visible}
            renderBeneficiados={getRandomInt(100)}
            tipoBeneficioInicial={tipoBeneficiadoInicial}
            actionType={!!initialData}
          />
        )
      },
      {
        key: 'ubicacion_web_hallazgo',
        label: 'Ubicación web del hallazgo',
        forceRender: true,
        children: <UbicacionWebHallazgo form={form} isLoading={isLoading} />
      },
      {
        key: 'firma',
        label: 'Firma',
        forceRender: true,
        children: <Firma form={form} isLoading={isLoading} />
      },
      {
        key: 'acuerdo_cof',
        label: 'Acuerdo de la COF',
        forceRender: true,
        children: (
          <AcuerdoCOF form={form} idProcesoGeneral={idProcesoGeneral} isLoading={isLoading} />
        )
      }
    ],
    [isLoading, form, tipoBeneficiadoInicial, idProcesoGeneral]
  );

  useEffect(() => {
    if (!visible) {
      form.resetFields();
      setTipoBeneficiadoInicial(null);
    }
  }, [visible]);

  useEffect(() => {
    if (!visible || !initialData?.tableRow) {
      const firmantes = {
        firmas: [
          {
            firmante: idUsuario
          }
        ]
      };
      form.setFieldsValue(firmantes);
      return;
    }
    const formatedMonitoreo = formatFromBackToForm(initialData.tableRow);
    form.setFieldsValue(formatedMonitoreo);
    const idFormato = initialData.tableRow.formatos?.[0]?.idFormato;
    setImagesFields(initialData.tableRow.hallazgos || [], idFormato, form);
    setSignerFields(initialData.tableRow.formatos?.[0] || [], form);
    const beneficiados = initialData.tableRow.formatos?.[0]?.beneficiados || [];
    const tipoBeneficio = initialData.tableRow.hallazgos?.[0]?.tipoBeneficio;
    setBeneficiados(beneficiados, tipoBeneficio, form);
    setTipoBeneficiadoInicial(tipoBeneficio);
    if (formatedMonitoreo.motivoCancelacion) {
      setReasonCancel(true);
    }
    setIdProcesoGeneral(initialData.tableRow.idProcesoGral);
  }, [visible, initialData]);

  const handleIdProcesoGralChange = (e, tipoAsociacionSelecionada) => {
    setIdProcesoGeneral(tipoAsociacionSelecionada.idProcesoElectoral);
  };

  return (
    <>
      <InfoModal
        visible={isVisibleSuccesModal}
        onClose={() => {
          setIdProcesoGeneral(0);
          setIsVisibleSuccessModal(false);
        }}
        description="El monitoreo se guardó con éxito."
      />
      <Modal
        title={initialData ? 'Editar' : 'Agregar'}
        wrapClassName="modal-formulario-monitoreo"
        open={visible}
        width="90%" // Se establece el tamaño asi por que antd sobreescribe el tamaño que se le pasa por clase
        onCancel={() => {
          handleCancel();
          setIdProcesoGeneral(0);
          setReasonCancel(false);
        }}
        cancelButtonProps={{ style: { display: 'none' } }}
        okButtonProps={{ style: { marginLeft: '-1em' }, loading: isLoading }}
        okText={initialData ? 'Guardar' : 'Generar monitoreo'}
        onOk={handleOK}>
        <div style={{ position: 'relative' }}>
          <LoadingCard visible={isLoading} />
          <div>
            <span className="folio-moni">
              Folio de monitoreo:{' '}
              <span className="value-folio">
                {initialData?.tableRow?.hallazgos?.[0]?.folioMonitoreo}
              </span>
            </span>
          </div>
          <div className="modal-formulario-subtitulo">
            <span className="modal-formulario-subtitulo-descripcion">
              Captura la información solicitada.
            </span>
            <span className="modal-formulario-subtitulo-requeridos">*Campos obligatorios.</span>
          </div>
          <Form layout="vertical" form={form}>
            <Row>
              <Col span={8}>
                <Form.Item
                  label="Proceso Electoral"
                  required
                  name="idProcesoGral"
                  rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}
                  style={{ width: '20em', margin: '1em 0' }}>
                  <Select
                    options={procesosElectorales}
                    placeholder="Selecciona el Proceso Electoral"
                    fieldNames={{
                      value: 'idProcesoElectoral',
                      label: 'descripcion'
                    }}
                    onSelect={handleIdProcesoGralChange}
                    disabled={isLoading}
                  />
                </Form.Item>
              </Col>
              {getMenuPermissions(menu, NOMBRE_MENU_INTERNET, null, NOMBRE_MENU_PERMISO_VALIDAR) ? (
                <div>
                  {initialData && (
                    <EstatusFormulario
                      form={form}
                      reasonCancel={reasonCancel}
                      setReasonCancel={setReasonCancel}
                    />
                  )}
                </div>
              ) : null}
            </Row>
          </Form>
          <Accordion
            items={items}
            className="modal-formulario-secciones"
            activeKey={activeKey}
            onChange={handleCollapseChange}
          />
        </div>
      </Modal>
    </>
  );
};

ModalFormularioMonitoreo.propTypes = {
  onClose: PropTypes.func.isRequired,
  visible: PropTypes.bool,
  initialData: PropTypes.shape({
    tableRow: PropTypes.shape({
      folio: PropTypes.string,
      hallazgos: PropTypes.arrayOf(
        PropTypes.shape({
          tipoBeneficio: PropTypes.number,
          folioMonitoreo: PropTypes.string
        })
      ),
      formatos: PropTypes.arrayOf(
        PropTypes.shape({
          idFormato: number,
          beneficiados: PropTypes.arrayOf(PropTypes.shape({}))
        })
      ),
      idProcesoGral: PropTypes.number
    })
  })
};

ModalFormularioMonitoreo.defaultProps = {
  visible: true,
  initialData: null
};
